angular.module('wbServices')
.service('analytics', ['$rootScope', '$window', ($rootScope, $window) ->
  return $window.analytics
])
